import { MutationOptions, useMutation } from "react-query";
import { APIError, APIResponse, API_URL, post } from "../api";

/**
 * Verifies the OTP sent to the user's support contact phone number.
 */
function useVerifyContactPhoneOtp(
  options?: MutationOptions<APIResponse<any>, APIError, Record<any, any>>
) {
  const {
    isLoading: validatingContactOTP,
    isError: isContactOTPError,
    error: contactOtpError,
    mutate: validateContactOTP,
  } = useMutation(async (variables?: Record<any, any>) => {
    return await post(
      API_URL +
        "/onboarding/users/onboarding/verifications/verify-contact-phone-otp",
      variables,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
  }, options);

  return {
    validateContactOTP,
    isContactOTPError,
    contactOtpError,
    validatingContactOTP,
  };
}

export default useVerifyContactPhoneOtp;
